import React from 'react'

import classNames from 'classnames'

import { FollowCheckIcon } from '@local/assets/icons'

import styles from './CheckInputRound.module.scss'

interface Props {
  checked?: boolean
  className?: string
}

const CheckInputRound: React.FC<Props> = ({ checked = false, className = '' }) => {
  return (
    <span className={classNames(styles.icon_wrapper, className, { [styles.type_checked]: checked })}>
      {checked ? <FollowCheckIcon className={styles.icon} aria-hidden="true" /> : null}
    </span>
  )
}

export default CheckInputRound
